import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'acc-responsibilities',
    standalone: false,
    template: `
        <span class="mr-2" *ngIf="icon && showComponent">
            <span class="fas fa-user" aria-hidden="true"></span>
            <span class="sr-only" translate>Responsibilities</span>
            {{ responsibilitiesString }}
        </span>
        <span *ngIf="!icon && showComponent">
            {{ responsibilitiesString }}
        </span>
    `,
})
export class AccResponsibilitiesComponent implements OnInit {
    @Input() responsibilities: any[] = [];
    @Input() icon?: boolean;

    showComponent: boolean = false;
    responsibilitiesString: string = '';

    constructor () {}

    ngOnInit () {
        this.showComponent = this.responsibilities.length > 0;
        this.responsibilitiesString = this.responsibilities.sort().join(', ');
        this.icon = this.icon || false;
    }
}
